import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { paths } from '@routes'
import { useDispatch, useSelector } from 'react-redux'
import { DRAWER_TYPES, strings } from '@constants'
import { displayName } from '@utils'
import { getAllOrgSuppliersApi, getUserAddressesApi } from '@data'
import AddItemsQuote from './components/AddItemsQuote'
import DispatchLocation from './components/DispatchLocation'
import { toggleDrawer } from '@data/state/action/root'
import { Address, SpoProductItem, SpoOrderQuote, User } from '@data/model'
import { BackButton, InfoMessage, InfoMessageWrapper, SectionHeader } from '@base'
import { FiberManualRecord } from '@material-ui/icons'
import MobileAmountSection from './components/MobileAmountSection'
import PriceValidityAndMOQ from './components/PriceValidityAndMOQ'
import AmountSection from './components/AmountSection'
import SPOFormWapper from './SPOFormWapper'

import { initialState, reducer } from './SPOForm/state/reducer'
import { addNewItemToEnquiry, deleteEnquiryItem, updateEnquiryItem, updateNewEnquiry } from './SPOForm/state/actions'
import { useReducerWithThunk } from '@hooks'
import { initialState as initialState2, reducer as reducer2, actions } from './ManageState'
import BillingAddress from './components/BillingAddress'
import PaymentTerms from './components/PaymentTerms'
import { createSupplierOrder } from '@data/conn/post/SupplyOrder'
import {
	ActionButton,
	ButtonsWrapper,
	CreateSpoFooter,
	CreateSpoWrapper,
	GstContainer,
	GstWapper,
	ItemsWrapper,
	PsuedoWrapper,
	SectionBody,
	StepWrapper,
	Wrapper,
} from '../style'
import TermsConditions from './components/TermsConditions'

const CreateSPO = ({ close, edit, data = null }) => {
	const navigate = useNavigate()
	const globalDispatch = useDispatch()
	// for add enquiry item
	const [state, dispatch] = useReducerWithThunk(reducer, initialState)
	// for manage enquiry item
	const [state2, dispatch2] = useReducer(reducer2, initialState2)

	const user = useSelector((state) => state.getIn(['user', 'user']))
	const commodityFilter = user?.commodity?.find((item) => item?.active)
	const [Suppliers, setSuppliers] = useState([])
	const [selectedSupplier, setSelectedSupplier] = useState()
	const [addresses, setAddresses] = useState()
	const [isAmountPanelOpen, setIsAmountPanelOpen] = useState(false)
	const [isLogisticsQuoteType, setIsLogisticsQuoteType] = useState(strings('mt'))
	const [amountPanelAnimation, setAmountPanelAnimation] = useState(true)

	const addNewItemToEnquiryCallback = (data) => dispatch(addNewItemToEnquiry(data))
	const updateEnquiryItemCallback = (id, data) => dispatch(updateEnquiryItem(id, data))
	const updateplatformcallback = (data) => dispatch(updateNewEnquiry({ platform: data }))
	const deleteEnquiryItemCallback = (data) => {
		dispatch(deleteEnquiryItem(data))
		dispatch2(actions.clearState())
		setSelectedSupplier()
		setAddresses()
	}

	const getState = () => state
	const enquiry = state.newEnquiry
	const enquiryItems = enquiry?.get('enquiry_items')
	const isScrap = false

	const newUserAddress = useRef(false)

	const checkScrap = enquiryItems?.find((_item) => _item.get('category_id')?.includes('scrap'))?.toJS() ?? {}

	useEffect(() => {
		dispatch2(actions.setEnquiryQuote(new SpoOrderQuote()))
	}, [])

	useEffect(() => {
		dispatch2(actions.setEnquiry(enquiry))
	}, [state])

	useEffect(() => {
		selectedSupplier &&
			getUserAddressesApi(selectedSupplier?.user_id)
				.then((res) => {
					if (res.length > 0) setAddresses(res)
				})
				.catch((e) => console.log(e))
	}, [selectedSupplier])

	useEffect(() => {
		getAllOrgSuppliersApi().then((response) => {
			setSuppliers(response)
		})

		return () => {
			// dispatch(clearNewEnquiryState())
		}
	}, [commodityFilter])

	const isValidQuote = (_quote) => Boolean(_quote.brand_ordered && _quote.required_weight && (_quote.price_per_kg || _quote.price_per_kg))

	useEffect(() => {
		if (!enquiryItems?.toJS()?.length) return
		let enquirySupplierQuote = state2.enquiryQuote
		state2.enquiry?.enquiry_items.forEach((item) => {
			const productQuoteTemp = new SpoProductItem(
				item.product_id,
				item.required_weight,
				item.product_name,
				item.category_name,
				item?.grade,
				item?.hsn_code,
				item?.price_per_kg
			)
			productQuoteTemp.isValid = isValidQuote(productQuoteTemp)
			enquirySupplierQuote.order_items.push(productQuoteTemp)
		})
		dispatch2(actions.setEnquiryQuote(enquirySupplierQuote))
	}, [state2.enquiry])

	useEffect(() => {
		if (state2?.enquiryQuote?.quote_type) {
			if (state2?.enquiryQuote?.quote_type !== strings('x') && !isAmountPanelOpen) {
				setAmountPanelAnimation(true)
			} else {
				setIsAmountPanelOpen(false)
			}
		}
	}, [state2?.enquiryQuote?.quote_type])

	useEffect(() => {
		let timeout

		if (isAmountPanelOpen) {
			setAmountPanelAnimation(false)
		}

		if (amountPanelAnimation) {
			clearTimeout(timeout)
			timeout = setTimeout(() => {
				setAmountPanelAnimation(false)
			}, 3000)
		}

		return () => {
			clearTimeout(timeout)
		}
	}, [amountPanelAnimation, isAmountPanelOpen])

	const staticData = useMemo(() => {
		const supplierQuote = state2.enquiryQuote?.order_items ?? []
		let totalAmount
		let totalExPrice = 0
		if (state2.enquiryQuote?.quote_type === strings('x')) {
			totalExPrice = supplierQuote.reduce((acc, quote) => (quote.price_per_kg ?? 0) * (quote.allotted_weight ?? 0) + acc, 0)

			const totalLogistics =
				isLogisticsQuoteType === strings('lumpsum')
					? parseFloat(state2.enquiryQuote.lumpsum_logistics_quote ?? 0)
					: (parseFloat(state2.enquiryQuote.logistics_quote_per_mt ?? 0) / 1000) *
					  supplierQuote.reduce(
							(acc, quote) => (quote.price_per_kg !== 0 || quote.price_per_kg !== 0 ? quote.allotted_weight ?? 0 : 0) + acc,
							0
					  )

			totalAmount = totalLogistics === 0 ? totalExPrice : totalLogistics + totalExPrice
		} else {
			totalAmount = supplierQuote.reduce((acc, quote) => (quote.price_per_kg ?? 0) * (quote.allotted_weight ?? 0) + acc, 0)
		}
		return {
			totalWeight: (supplierQuote ?? []).reduce((acc, item) => acc + item.allotted_weight, 0),
			shippingAddress: new Address(state2.enquiry?.shipping_address).getCityState(),
			totalExPrice,
			totalAmount,
		}
	}, [state2])

	const setQuoteType = (type) => (e) => {
		e.stopPropagation()
		const quoteType = state2.enquiryQuote?.quote_type

		if (quoteType === type) return

		const updatedEnquiryQuote = {
			...state2.enquiryQuote,
			quote_type: type,
			logistics_quote_per_mt: 0,
			lumpsum_logistics_quote: 0,
			minimum_guaranteed_weight: 0,
			minimum_order_quantity: 0,
		}
		dispatch2(actions.setEnquiryQuote(updatedEnquiryQuote))
	}

	const { isQuoteTypeX, noOfValidQuotes } = useMemo(() => {
		return {
			isQuoteTypeX: state2.enquiryQuote?.quote_type === strings('x'),
			noOfValidQuotes: Array.isArray(state2.enquiryQuote?.order_items) ? state2.enquiryQuote?.order_items.filter((_q) => _q.isValid).length : 0,
		}
	}, [state2])

	const valueChangeHandler = (productId, key) => (value) => {
		if (
			key === 'dispatch_location' ||
			key === 'quote_valid_till' ||
			key === 'message' ||
			key === 'order_given' ||
			key === 'original_supplier_po_number' ||
			key === 'supplier_po_date' ||
			key === 'billing_address' ||
			key === 'payment_terms_list' ||
			key === 'terms_and_conditions'
		) {
			state2.enquiryQuote[key] = value
		} else {
			state2.enquiryQuote[key] = value === '' ? null : parseFloat(value)
			if (isLogisticsQuoteType === strings('lumpsum')) {
				state2.enquiryQuote['logistics_quote_per_mt'] = 0
			}
			if (isLogisticsQuoteType === strings('mt')) {
				state2.enquiryQuote['lumpsum_logistics_quote'] = 0
			}
		}
		dispatch2(actions.setEnquiryQuote(state2.enquiryQuote))
	}
	const userChangeHandler = (_user) => {
		if (!user) return
		setSelectedSupplier(_user)
		state2.enquiryQuote.supplier = new User(_user).getUserDetails()
		dispatch2(actions.setEnquiryQuote(state2.enquiryQuote))
	}

	//   start users action //
	const _suppliers = useMemo(
		() =>
			Suppliers?.map((item) => {
				item['display_name'] = displayName(item)
				return item
			}),
		[Suppliers]
	)

	// user action end //

	const editItemButtonClick = (id) => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.EDIT_SPO_ITEM, {
				itemId: id,
				getState,
				defualtCategoryId: enquiry?.platform?.includes('SCRAP') ? checkScrap?.category_id : null,
				addNewItemToEnquiryCallback,
				deleteEnquiryItemCallback,
				updateEnquiryItemCallback,
				dispatch: dispatch,
				activeCommodity: false,
			})
		)
	}

	const submitQuoteHandler = () => {
		const finalPayload = { ...state2.enquiryQuote, supplier_po_amount: staticData?.totalAmount }
		createSupplierOrder(finalPayload)
			.then((res) => {
				navigate(paths.admin_manage_spo)
			})
			.catch((err) => console.log(err))
	}

	const renderStaticMessages = () => (
		<InfoMessageWrapper>
			{strings('msg_quote_trader').map((item, index) => (
				<InfoMessage key={`message-${index}`}>
					<FiberManualRecord />
					<span>{item}</span>
				</InfoMessage>
			))}
		</InfoMessageWrapper>
	)

	const renderFooterContent = () => {
		// const disabled =
		// 	noOfValidQuotes <= 0 ||
		// 	!selectedSupplier ||
		// 	!state.enquiryQuote?.dispatch_location ||
		// 	(isQuoteTypeX && (state.enquiryQuote?.minimum_guaranteed_weight === null || state.enquiryQuote?.logistics_quote_per_mt === null))
		// const scrapDisabled = staticData.totalAmount === 0 || !state.enquiryQuote?.dispatch_location || !selectedSupplier
		return (
			<>
				<BackButton xs onClick={close} type='secondary'>
					<span>{strings('close')}</span>
				</BackButton>
				<ActionButton
					xs
					type='primary'
					margin='0 0 0 auto'
					// disabled={isScrap ? scrapDisabled : disabled}
					onClick={submitQuoteHandler}
				>
					{strings('create', 'spo')}
				</ActionButton>
			</>
		)
	}

	const dispatchLocationHandler = () => {
		const addDispatchLocation = (address, isNew = false) => {
			newUserAddress.current = isNew
			valueChangeHandler(null, 'dispatch_location')(address)
		}
		const addNewAddressHandler = () => {
			globalDispatch(
				toggleDrawer(true, DRAWER_TYPES.ADD_NEW_ADDRESS, {
					addCallback: (address) => {
						addDispatchLocation(address, true)
					},
					label: strings('add_new_address'),
				})
			)
		}
		return (
			<DispatchLocation
				state={state}
				addresses={addresses}
				addNewAddressHandler={addNewAddressHandler}
				addDispatchLocation={addDispatchLocation}
				dispatchLocation={state2?.enquiryQuote?.dispatch_location}
			/>
		)
	}

	return (
		<Wrapper>
			<CreateSpoWrapper>
				<SPOFormWapper
					state={state}
					state2={state2}
					valueChangeHandler={valueChangeHandler}
					dispatch={dispatch}
					_suppliers={_suppliers}
					selectedSupplier={selectedSupplier}
					userChangeHandler={userChangeHandler}
					addNewItemToEnquiryCallback={addNewItemToEnquiryCallback}
					deleteEnquiryItemCallback={deleteEnquiryItemCallback}
					updateEnquiryItemCallback={updateEnquiryItemCallback}
					updateplatformcallback={updateplatformcallback}
				/>
				<StepWrapper>
					<SectionHeader>{strings('quotes')}</SectionHeader>
					<SectionBody>
						<ItemsWrapper>
							<AddItemsQuote state={state} isScrap={isScrap} editItemButtonClick={editItemButtonClick} />
						</ItemsWrapper>
						<AmountSection
							state2={state2}
							isScrap={isScrap}
							isQuoteTypeX={isQuoteTypeX}
							valueChangeHandler={valueChangeHandler}
							isLogisticsQuoteType={isLogisticsQuoteType}
							setIsLogisticsQuoteType={setIsLogisticsQuoteType}
							staticData={staticData}
							setQuoteType={setQuoteType}
							renderStaticMessages={renderStaticMessages}
						/>
					</SectionBody>
				</StepWrapper>
				{dispatchLocationHandler()}
				<GstContainer>
					<GstWapper>
						<BillingAddress state2={state2} valueChangeHandler={valueChangeHandler} />
					</GstWapper>
					<GstWapper>
						<PaymentTerms state2={state2} valueChangeHandler={valueChangeHandler} />
					</GstWapper>
				</GstContainer>
				<TermsConditions state2={state2} valueChangeHandler={valueChangeHandler} />
				<PriceValidityAndMOQ state={state2} valueChangeHandler={valueChangeHandler} />
			</CreateSpoWrapper>
			<PsuedoWrapper>
				<CreateSpoFooter>
					<MobileAmountSection
						isScrap={isScrap}
						state={state2}
						valueChangeHandler={valueChangeHandler}
						isLogisticsQuoteType={isLogisticsQuoteType}
						isAmountPanelOpen={isAmountPanelOpen}
						isQuoteTypeX={isQuoteTypeX}
						setIsAmountPanelOpen={setIsAmountPanelOpen}
						setQuoteType={setQuoteType}
						staticData={staticData}
						amountPanelAnimation={amountPanelAnimation}
						renderStaticMessages={renderStaticMessages}
					/>
					<ButtonsWrapper>{renderFooterContent()}</ButtonsWrapper>
				</CreateSpoFooter>
			</PsuedoWrapper>
		</Wrapper>
	)
}

export default CreateSPO
